<template>
	<!-- 사용자 이름, 사용자 설정 사이드 바 닫기 버튼, 사용자 비밀번호 변경 버튼 -->
	<sf-user-sidebar :userName="user.userName" :closeUserSide="toggleUserSide" :changePassword="changePassword">
		<template v-slot:setting>
			<!-- 사용자 설정 Form -->
			<user-setting />
		</template>
		<template v-slot:footer>
			<!-- 다국어: 로그아웃 -->
			<sf-button line :onClick="logout">{{ getMessage_('SWCC000411') }}</sf-button>
		</template>
	</sf-user-sidebar>
</template>

<script>
//사용자 설정 사이드 바
import { rootComputed, rootMethods } from '@/store/common/helpers';
import UserSetting from './UserSetting/UserSetting';

export default {
	components: { UserSetting },

	computed: {
		...rootComputed
	},
	methods: {
		...rootMethods,

		//사용자 설정 사이드 바 토클 매서드
		toggleUserSide() {
			this.$emit('toggleUserSide'); //상단 메뉴 클릭 이벤트 호출
		},

		//사용자 비밀번호 변경
		changePassword() {
			this.$router.push('/reset').catch(() => {}); //사용자 비밀번호 변경 페이지로 이동
		},

		//로그아웃
		logout() {
			this.$sf_toggleLoading(true);

			//사용자 로그아웃 Action 호출
			this.logout_()
				.then(header => {
					//로그아웃 성공 시
					if (header.code === 0) {
						this.$sf_removeAll();
						this.$router.push('/login').catch(() => {}); //로그인 페이지로 이동
					} else {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
